/**
 * Display helpers for patient identity strips (PatientHero,
 * PatientBanner, assessment-report compact banner). Pure functions:
 * callers pass the relevant i18n namespaces; every label falls back
 * to the previous hard-coded English form when a key is missing.
 */

const capitalize = value =>
  String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase();

export const getGenderLabel = (gender, forms = {}) => {
  if (!gender) return '';
  const byValue = { female: forms.female, male: forms.male };
  return byValue[String(gender).toLowerCase()] || capitalize(gender);
};

export const getAgeGenderLine = ({ age, gender }, { forms = {}, patientHero = {} } = {}) => {
  const parts = [];
  if (age != null && age !== '') parts.push(`${age} ${patientHero.yearsOld || 'y.o.'}`);
  const genderLabel = getGenderLabel(gender, forms);
  if (genderLabel) parts.push(genderLabel);
  return parts.join(' · ');
};

// Patient language arrives as a lowercase enum value
// ('english' | 'spanish' | 'unknown').
const LANGUAGE_LABEL_KEYS = {
  english: 'languageEnglish',
  spanish: 'languageSpanish',
  unknown: 'languageUnknown',
};

export const getPatientLanguageLabel = (language, patientOptions = {}) => {
  if (!language) return '';
  const key = LANGUAGE_LABEL_KEYS[String(language).toLowerCase()];
  return (key && patientOptions[key]) || capitalize(language);
};
